<template>
  <b-modal
    id="modal-create-flag"
    ref="modal"
    v-model="open"
    size="ov-custom"
    centered
    hide-footer
    title="Add New Flag"
  >
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <ValidationObserver
        ref="createFlag"
        v-slot="{ handleSubmit }"
        slim
      >
        <b-form
          class="my-8"
          @submit.prevent="handleSubmit(onClickCreateFlag)"
        >
          <b-row class="mb-4">
            <b-col
              cols="9"
            >
              <b-form-group
                label="Flag Name"
                label-for="h-name"
                label-cols-md="3"
              >
                <b-form-input
                  id="Flag Name"
                  v-model="flagOptions.name"
                  placeholder="Enter Flag Name"
                  autocomplete="nope"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col
              cols="9"
              md="6"
            >
              <b-form-group
                label="Flaged By"
                label-for="h-name"
                label-cols-md="3"
              >
                <b-col
                  cols="6"
                >
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="flagOptions.is_staff_enable"
                  >
                    Staff Enable
                  </b-form-checkbox>
                </b-col>
                <b-col
                  cols="6"
                >
                  <b-form-checkbox
                    id="checkbox-2"
                    v-model="flagOptions.is_merchant_enable"
                  >
                    Merchant Enable
                  </b-form-checkbox>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col
              cols="9"
              md="6"
            >
              <b-form-group
                label="Status"
                label-for="h-active"
                label-cols-md="3"
              >
                <b-col
                  cols="6"
                >
                  <b-form-checkbox
                    id="checkbox-3"
                    v-model="flagOptions.is_active"
                  >
                    Active
                  </b-form-checkbox>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>
          <b-col
            class="mb-2"
            offset-md="4"
          >
            <b-button
              v-can="'flag-edit'"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              :disabled="flagOptions.type === 'flag_7'"
            >
              Submit
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              :disabled="flagOptions.type === 'flag_7'"
              @click="clearForm"
            >
              Clear
            </b-button>
          </b-col>
        </b-form>
      </ValidationObserver>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  VBModal,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BButton,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Ripple from 'vue-ripple-directive'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const flagRepository = RepositoryFactory.get('flag')

export default {
  name: 'ManageFlag',
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BModal,
    BOverlay,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BButton,
    BFormGroup,
    BFormInput,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      open: false,
      signatureOpen: false,
      modalLoading: false,
      loading: false,
      id: null,
      items: {},
      perPage: 10,
      flagOptions: {
        name: '',
        is_staff_enable: false,
        is_merchant_enable: false,
        is_active: false,
      },
    }
  },
  methods: {
    async openModal() {
      this.open = true
      this.modalLoading = true
      this.modalLoading = false
    },
    async onClickCreateFlag() {
      try {
        this.loading = true
        const payload = {
          is_staff_enable: this.flagOptions.is_staff_enable,
          is_merchant_enable: this.flagOptions.is_merchant_enable,
          is_active: this.flagOptions.is_active,
          name: this.flagOptions.name,
        }
        const res = await flagRepository.addNewFlagDetail(payload)
        if (res.status === 201) {
          this.open = false
          this.showSuccessMessage(`${this.flagOptions.name}  added successfully`)
          this.$parent.onClickRefresh()
        } else {
          this.showErrorMessage(`Cannot add ${this.flagOptions.name}`)
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    clearForm() {
      this.flagOptions = {}
    },
  },
}
</script>
  <style scoped>
  b-form-checkbox{
    margin-bottom: 10px;
  }
    @media (min-width: 767px) {
      .status-bar {
        padding : 1rem;
      }
    }
  .custom-control {
      position: relative;
      z-index: 1;
      display: block;
      min-height: 1.45rem;
      margin-bottom: 15px;
    }
  </style>
